import styled from "styled-components";

export default styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 80px;
  max-height: 550px;
  overflow: hidden;

  &.large {
    margin-top: 40px;
    margin-bottom: 10px;
  }
`;
